import { render, staticRenderFns } from "./workFlow.vue?vue&type=template&id=f99854fe"
import script from "./workFlow.vue?vue&type=script&lang=js"
export * from "./workFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports